import { CONTRACTOR_SUB_TYPES } from '@/store/modules/legal-entity/constants'

const CONTRACTOR_SUB_TYPE_LABELS = {
  independent_contractor: 'Independent Contractors',
  agency: 'Agency',
  marketplace: 'Marketplace'
}

const PAYMENT_TYPE_LABELS = {
  employee: 'Employees',
  contractor: 'Contractors'
}

const CONTRACTOR_SUB_TYPE_ORDER = ['agency', 'independent_contractor', 'marketplace']

const normalizePaymentType = item => {
  const value = item?.id ?? item?.name ?? item

  return typeof value === 'string' ? value.toLowerCase() : value
}

const normalizeContractorSubType = item => {
  const value = item?.id ?? item?.name ?? item

  return CONTRACTOR_SUB_TYPES.find(subType => subType.id === value || subType.name === value)?.id ?? value
}

export const formatContractorSubTypes = (contractorSubTypes = []) => {
  const selectedSubTypes = contractorSubTypes.map(normalizeContractorSubType)
  const selectedKnownSubTypes = new Set(
    selectedSubTypes.filter(item => CONTRACTOR_SUB_TYPES.some(subType => subType.id === item))
  )

  if (!selectedSubTypes.length) {
    return 'Contractors'
  }

  if (CONTRACTOR_SUB_TYPES.every(subType => selectedKnownSubTypes.has(subType.id))) {
    return 'Contractors'
  }

  if (selectedSubTypes.length === 1 && selectedSubTypes[0] === 'independent_contractor') {
    return 'Independent Contractors'
  }

  const sortedSubTypes = [
    ...CONTRACTOR_SUB_TYPE_ORDER.filter(item => selectedSubTypes.includes(item)),
    ...selectedSubTypes.filter(item => !CONTRACTOR_SUB_TYPE_ORDER.includes(item))
  ]

  return sortedSubTypes.map(item => CONTRACTOR_SUB_TYPE_LABELS[item] ?? item).join(' and ')
}

export const formatTargetPaymentTypes = (paymentTypes = [], contractorSubTypes = []) => {
  const selectedPaymentTypes = paymentTypes.map(normalizePaymentType)
  const targetPaymentTypes = []

  if (selectedPaymentTypes.includes('employee')) {
    targetPaymentTypes.push(PAYMENT_TYPE_LABELS.employee)
  }

  if (selectedPaymentTypes.includes('contractor')) {
    targetPaymentTypes.push(formatContractorSubTypes(contractorSubTypes))
  }

  return targetPaymentTypes.join(', ')
}
